import { resources } from './../settings/MockSettings'

const getResourceList = async ({queryKey}) => {
    const [_key, { resourceName }] = queryKey

    return new Promise((resolve, reject) => {
        const data = resources.get(resourceName).data
        
        resolve(data)        
    })
}

const getResource = async ({queryKey}) => {
    const [_key, { resourceName, resourceId, resourceIdAttribute = 'id' }] = queryKey

    return new Promise((resolve, reject) => {
        const data = resources.get(resourceName).data.find(item => {
            return item[resourceIdAttribute] === resourceId
        })

        resolve(data)
    })
}

export {
    getResourceList,
    getResource,
}